export default {"src":"/_next/static/media/tab_option.a5443921.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};